export const columnsConfig = [
  {
    id: "id",
    header: "",
    size: 60,
    type: "checkbox",
    getColumnDisplayValue: () => "",
  },
  {
    id: "eventname",
    header: "Event Name",
    size: 400,
    getColumnDisplayValue: ({ title }) => title || "",
  },
  {
    id: "category_name",
    header: "Category",
    size: 400,
    getColumnDisplayValue: ({ category_name }) => category_name || "",
  },
  {
    id: "duration",
    header: "Duration",
    size: 200,
    getColumnDisplayValue: ({ duration }) => duration,
  },
  {
    id: "location",
    header: "Location",
    size: 200,
    type: "html",
    getColumnDisplayValue: ({ location }) => location || "",
  },
  {
    id: "departurecity",
    header: "Departure City",
    size: 200,
    getColumnDisplayValue: ({ departure_city, departure_city_country_id }) => 
      [departure_city, departure_city_country_id].filter(Boolean).join(", ") || "",
  },
  {
    id: "startdateandtime",
    header: "Start Date & Time",
    size: 200,
    getColumnDisplayValue: ({ start_date, start_date_time, start_date_timezone }) => 
      [start_date, start_date_time, start_date_timezone].filter(Boolean).join(" ") || "",
  },
  {
    id: "organizedby",
    header: "Organized By",
    size: 200,
    getColumnDisplayValue: ({ host }) => host,
  },
  {
    id: "price_student",
    header: "Price",
    size: 200,
    getColumnDisplayValue: ({ price_student }) => price_student,
  },
];

export const fromTableColumnsConfig = [
  {
    id: "event",
    header: "Event",
    size: 520,
    getColumnDisplayValue: ({ title }) => title || "",
  },
  {
    id: "location",
    header: "Location",
    size: 300,
    getColumnDisplayValue: ({ location }) => location || "",
  },
  {
    id: "price",
    header: "Price",
    size: 100,
    getColumnDisplayValue: ({ price_student }) => price_student,
  },
  // {
  //   id: "default",
  //   header: "default",
  //   size: 60,
  //   type: "radio",
  //   getColumnDisplayValue: () => "",
  // },
  {
    id: "id",
    header: "",
    size: 20,
    type: "trash",
    getColumnDisplayValue: () => "",
  },
];
